import React, {useState} from 'react';
import './BoxVideo.css';

function BoxVideo({title, description, embed, type = "", bColor}) {
    const [showType] = useState(true);

    return (
        <div className="box_video_components">
            <div className="box_video">
                <iframe
                    src={`https://www.youtube.com/embed/${embed}`}
                    // src='https://www.youtube.com/embed/Wlq-T2cUO2w'
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                    title="Embedded youtube"
                    // onChange={(e)=>onVideoStateChange(e)}
                />
            </div>
            <div className="box_video_info">
                <span className="box_video_title">
                    {title}
                </span>
                <span className="box_video_description">
                    {description}
                </span>
                {
                    type !== "" && showType && 
                    <span className='box_video_span_info' style={{backgroundColor: bColor}}>
                        {
                            type
                        }
                    </span>
                }
            </div>
        </div>
    );
}

export default BoxVideo;